import styled from "styled-components";

/* What the action does, one paragraph each */
export const Descriptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
`;
